export default {
  // TODO this seemed like a nice idea but we should just the message coming from firebase and then figure out how to get it to speak german
  'auth/email-already-in-use': 'Diese E-Mail-Adresse wird bereits verwendet!',
  'auth/weak-password': 'Das Passwort ist nicht stark genug!',
}
